import { combineEpics } from 'redux-observable';
import { merge, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { esbApi } from '@modules/rtk/esb-api';
import tagFactory from '@modules/rtk/utils/tagFactory';
import { catchAndReport } from '@utils/rxjs/operators';

import {
  DECLINE_ADVANCEMENT_REQUEST,
  clearAdvancementsToDecline,
  closeDeclineAdvancementsModal,
  declineAdvancementRequestError,
  declineAdvancementResponse,
} from './actions';
import services from './services';

const declineActivityEpic$ = action$ =>
  action$
    .ofType(DECLINE_ADVANCEMENT_REQUEST)
    .switchMap(({ payload: { organizationGuid, activities, userId } }) =>
      services.declineActivity$({ organizationGuid, activities }).pipe(
        mergeMap(() => {
          const invalidate = [
            tagFactory.Activities.orgActivities(organizationGuid),
            tagFactory.UserActivitySummary.userSummary(userId),
            ...activities.map(activity =>
              tagFactory.Activities.activityItem(activity.activityId),
            ),
          ];
          return merge(
            of(declineAdvancementResponse()),
            of(closeDeclineAdvancementsModal()),
            of(clearAdvancementsToDecline()),
            of(esbApi.util.invalidateTags(invalidate)),
          );
        }),
        catchAndReport(err => of(declineAdvancementRequestError(err))),
      ),
    );

export default combineEpics(declineActivityEpic$);
